/**
 * API client for ADRL health endpoints (admin backend, port 8001).
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

export async function fetchSummary() {
  const res = await fetch(`${API_URL}/api/adrl-health/summary`);
  if (!res.ok) throw new Error(`Failed to fetch summary: ${res.status}`);
  return res.json();
}

export async function fetchPrograms(status) {
  const params = status ? `?status=${status}` : '';
  const res = await fetch(`${API_URL}/api/adrl-health/programs${params}`);
  if (!res.ok) throw new Error(`Failed to fetch programs: ${res.status}`);
  return res.json();
}

export async function fetchMappings(adrlFileId) {
  const params = adrlFileId ? `?adrl_file_id=${adrlFileId}` : '';
  const res = await fetch(`${API_URL}/api/adrl-health/mappings${params}`);
  if (!res.ok) throw new Error(`Failed to fetch mappings: ${res.status}`);
  return res.json();
}
